import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px 60px 60px 60px;
  border-radius: 50px;
  max-width: 900px;
  width: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
}`;

export const ModalTitle = styled.h1`
  font-size: 2.5rem;
}`;

export const StyledLogo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 24px;
  gap: 10px;
  border-radius: 8px;
  background: ${customPalette.accent.main};
`;

export const LogoText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AppTitle = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${customPalette.accent.white};
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${customPalette.accent.white};
`;

export const ModalBody = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Paragraph = styled.p`
  font-size: 24px;
  line-height: 1.5;
`;
